import { render, staticRenderFns } from "./add-synthesis.vue?vue&type=template&id=3932121c&scoped=true&"
import script from "./add-synthesis.vue?vue&type=script&lang=js&"
export * from "./add-synthesis.vue?vue&type=script&lang=js&"
import style0 from "./add-synthesis.vue?vue&type=style&index=0&id=3932121c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3932121c",
  null
  
)

export default component.exports